// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { APP_CONFIG } from "src/app/helper/Appcode/app-config.service";

export const environment = {
  production: false,
  webapiurl : APP_CONFIG.webapiurl, // 'https://localhost:44342/api/'//  // 'http://timecontrolapi.awaneg.com/api/'  "https://timecontrolapi.awan-is.com/api/"
  mapboxapi : 'pk.eyJ1IjoiZXNsYW1tb2hhbWVkNDEiLCJhIjoiY2t0OXJ0ZGR5MWY2eTJwanB4MXM2aW5yNSJ9.d5ptPfxXSbC2fynF04D2ZQ'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
